module.exports = "/assets/data/497de0da83a5e4142b3ebc29a3d79b20-CF81.data.json";